import { reactErrorHandler } from '@sentry/react'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import { FeatureFlagsProvider } from './api/feature-flags'
import './i18n'
import './index.css'
import './sentry.ts'

const container = document.getElementById('root')

if (!container) {
  throw new Error('No root element found')
}

const root = createRoot(container, {
  onUncaughtError: reactErrorHandler((error, errorInfo) => {
    console.warn('Uncaught error', error, errorInfo.componentStack)
  }),
  onCaughtError: reactErrorHandler(),
  onRecoverableError: reactErrorHandler(),
})

const queryClient = new QueryClient()

root.render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <FeatureFlagsProvider>
        <App />
      </FeatureFlagsProvider>
    </QueryClientProvider>
  </StrictMode>,
)
